export const defaultFormVal = {
  "welcome_message": {
      "en": "<div></div>",
      "de": "<div></div>",
      "it": "<div></div>",
      "nl": "<div></div>"
  },
  "thank_you_message": {
      "en": "<div></div>",
      "de": "<div></div>",
      "it": "<div></div>",
      "nl": "<div></div>"
  },
  "closed_message": {
    "en": "<div></div>",
    "de": "<div></div>",
    "it": "<div></div>",
    "nl": "<div></div>"
  },
  "reminder_duration": 0,
  "dialogue_fields": [],
  
  "header_background_color": '#00365E',
  "customer_message_background_color": '#6084A0',
  "support_message_background_color": '#B3C7D4',
  "background_text_font_color": '#FFFFFF',
  "message_text_font_color": '#FFFFFF',
  "background_image": 'https://d3386uh5nemg6b.cloudfront.net/center_media_drive/6b180037abbebea991d8b1232f8a8ca9/original/dialog-default-background.webp',
  "chat_logo": 'https://d3386uh5nemg6b.cloudfront.net/center_media_drive/5d616dd38211ebb5d6ec52986674b6e4/original/dialog-default_icon.webp',
}

export const dialogueField = {
    "title": {
        "en": "",
        "de": "",
        "it": "",
        "nl": ""
    },
    "is_show": true,
    "is_mandatory": true
}

export const defaultOperatingHours = {
  "translation_id": null,
  "language": "",
  "timezone": "",
  "week_days": [
      {
          "week_day": 0,
          "timeslots": [
              {
                  "start_time": "00:00",
                  "end_time": "01:00"
              }
          ]
      },
      {
          "week_day": 1,
          "timeslots": [
              {
                  "start_time": "00:00",
                  "end_time": "01:00"
              }
          ]
      },
      {
          "week_day": 2,
          "timeslots": [
              {
                  "start_time": "00:00",
                  "end_time": "01:00"
              }
          ]
      },
      {
        "week_day": 3,
        "timeslots": [
            {
                "start_time": "00:00",
                "end_time": "01:00"
            },
        ]
      },
      {
          "week_day": 4,
          "timeslots": [
              {
                  "start_time": "00:00",
                  "end_time": "01:00"
              }
          ]
      },
      {
        "week_day": 5,
        "timeslots": [
            {
                "start_time": "00:00",
                "end_time": "01:00"
            }
        ]
    },
    {
      "week_day": 6,
      "timeslots": [
          {
              "start_time": "00:00",
              "end_time": "01:00"
          }
      ]
    }
  ]
}

export const sampleTranslation = {
"id": 48,
"site_id": 1,
"slug": "/de-ch",
"language": "de",
"is_default": false,
"updated_at": "2024-09-12T09:08:36.135615Z",
"created_at": "2024-09-12T09:08:36.135615Z",
"is_x_default_hreflang": false,
"is_show_language_dropdown": true
}